import { render, staticRenderFns } from "./CardPropertyVertical.vue?vue&type=template&id=43fdc139"
import script from "./CardPropertyVertical.vue?vue&type=script&lang=js"
export * from "./CardPropertyVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports